"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const ProductSubscribedResponseResource_1 = __importDefault(require("../ProductSubscribed/ProductSubscribedResponseResource"));
const Resource_1 = __importDefault(require("../Resource"));
const UserPublicResponseResource_1 = __importDefault(require("../User/UserPublicResponseResource"));
const CommunitySpouseDetailsResponseResource_1 = __importDefault(require("./CommunitySpouseDetails/CommunitySpouseDetailsResponseResource"));
const SubscriptionFileResponseResource_1 = __importDefault(require("./Files/SubscriptionFileResponseResource"));
const GenericAutreCgpResponseResource_1 = __importDefault(require("./SubscriptionQuestions/GenericAutreCgpResponseResource"));
const GenericConnaissanceExperienceResponseResource_1 = __importDefault(require("./SubscriptionQuestions/GenericConnaissanceExperienceResponseResource"));
const GenericFinanceDurableResponseResource_1 = __importDefault(require("./SubscriptionQuestions/GenericFinanceDurableResponseResource"));
const GenericPatrimoineResponseResource_1 = __importDefault(require("./SubscriptionQuestions/GenericPatrimoineResponseResource"));
const GenericTestAdequationResponseResource_1 = __importDefault(require("./SubscriptionQuestions/GenericTestAdequationResponseResource"));
const ESubscriptionType_1 = require("../../enums/Subscription/ESubscriptionType");
const SubscriptionAnomalyReport_1 = __importDefault(require("./SubscriptionAnomalyReport"));
const SubscriptionInvestorInvitationResponseResource_1 = __importDefault(require("./SubscriptionInvestorInvitationResponseResource"));
class SubscriptionResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.productsSubscribed = [];
        this.files = [];
    }
}
exports.default = SubscriptionResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SubscriptionResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SubscriptionResponseResource.prototype, "creatorId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => UserPublicResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "creator", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSubscribedResponseResource_1.default),
    __metadata("design:type", Array)
], SubscriptionResponseResource.prototype, "productsSubscribed", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionTitularyName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBankDomiciliation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionIban", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBic", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBankAddress", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBankCity", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBankZipCode", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBankCountry", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionAccountNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionAba", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionBankContact", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "perceptionHasIban", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "fundsOrigin", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "fundsOriginCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "fundsOriginOther", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "fundsOriginSavings", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "apportCompteCourant", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "financialObjective", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "signaturePlace", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "paymentByTier", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "paymentByTierMotive", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "paymentFromFrenchAccount", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "paymentFromCountry", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => GenericAutreCgpResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "autreCGP", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => GenericFinanceDurableResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "financeDurable", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => GenericTestAdequationResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "testAdequation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => GenericPatrimoineResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "patrimoineRevenus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => GenericConnaissanceExperienceResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "connaissanceExperience", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubscriptionFileResponseResource_1.default),
    __metadata("design:type", Array)
], SubscriptionResponseResource.prototype, "files", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], SubscriptionResponseResource.prototype, "subscriptionType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "communityInvestment", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "fundsOriginCommunityInvestment", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "fundsOriginCommunityInvestmentOther", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => CommunitySpouseDetailsResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "communitySpouseDetails", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "manuallySentLegalDocumentsAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "updatedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "validatedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "rtoDocumentsStatus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubscriptionAnomalyReport_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "rtoAnomalyReported", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "hasAcceptedConditions", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubscriptionInvestorInvitationResponseResource_1.default),
    __metadata("design:type", Object)
], SubscriptionResponseResource.prototype, "investorInvitation", void 0);
